export function FipeArrowIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41681 8.80061L4.4959 6.87969C4.26781 6.65161 3.89915 6.65161 3.67106 6.87969C3.44298 7.10778 3.44298 7.47644 3.67106 7.70453L6.58715 10.6212C6.6414 10.6749 6.70615 10.7174 6.77731 10.7472C6.91965 10.8061 7.08065 10.8061 7.22298 10.7472C7.29415 10.7174 7.3589 10.6749 7.41315 10.6212L10.3292 7.70453C10.443 7.59078 10.5001 7.44144 10.5001 7.29211C10.5001 7.14278 10.443 6.99344 10.3292 6.87969C10.1011 6.65161 9.73248 6.65161 9.5044 6.87969L7.58348 8.80061V3.79211C7.58348 3.47011 7.32215 3.20878 7.00015 3.20878C6.67815 3.20878 6.41681 3.47011 6.41681 3.79211V8.80061Z"
        fill="#134D2C"
      />
    </svg>
  );
}
